<div class="tour-overlay" *ngIf="isVisible" [class.rtl]="isRtl">
  <!-- Backdrop: 4 rectangles around the cutout hole -->
  <ng-container *ngIf="highlightRect">
    <!-- Top -->
    <div class="tour-backdrop-piece"
      [style.top.px]="0"
      [style.left.px]="0"
      [style.width]="'100vw'"
      [style.height.px]="highlightRect.top - 8">
    </div>
    <!-- Bottom -->
    <div class="tour-backdrop-piece"
      [style.top.px]="highlightRect.top + highlightRect.height + 8"
      [style.left.px]="0"
      [style.width]="'100vw'"
      [style.bottom.px]="0">
    </div>
    <!-- Left -->
    <div class="tour-backdrop-piece"
      [style.top.px]="highlightRect.top - 8"
      [style.left.px]="0"
      [style.width.px]="highlightRect.left - 8"
      [style.height.px]="highlightRect.height + 16">
    </div>
    <!-- Right -->
    <div class="tour-backdrop-piece"
      [style.top.px]="highlightRect.top - 8"
      [style.left.px]="highlightRect.left + highlightRect.width + 8"
      [style.right.px]="0"
      [style.height.px]="highlightRect.height + 16">
    </div>
  </ng-container>

  <!-- Full backdrop when no target element -->
  <div class="tour-backdrop-full" *ngIf="!highlightRect"></div>

  <!-- Highlight ring (pulsing border around the target) -->
  <div
    class="tour-highlight-ring"
    *ngIf="highlightRect"
    [style.top.px]="highlightRect.top - 8"
    [style.left.px]="highlightRect.left - 8"
    [style.width.px]="highlightRect.width + 16"
    [style.height.px]="highlightRect.height + 16">
  </div>

  <!-- Tooltip card (hidden until positioned to prevent flash) -->
  <div
    class="tour-tooltip"
    #tooltipEl
    [class.tour-tooltip-ready]="isPositioned"
    [ngStyle]="tooltipStyle">
    <div class="tour-tooltip-content">
      <p class="tour-tooltip-text">{{ tooltipText }}</p>
      <div class="tour-tooltip-footer">
        <span class="tour-step-counter">{{ stepCounter }}</span>
        <div class="tour-tooltip-actions">
          <button
            class="tour-btn tour-btn-skip"
            (click)="onSkipClick()">
            {{ 'tour.skip-tour' | translate }}
          </button>
          <button
            *ngIf="showNextButton && !isLastStep"
            class="tour-btn tour-btn-next"
            (click)="onNextClick()">
            {{ 'tour.next' | translate }}
          </button>
          <button
            *ngIf="isLastStep"
            class="tour-btn tour-btn-next"
            (click)="onNextClick()">
            {{ 'tour.go-to-home' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
